import { TariffKindInternal } from '../../../../../../../data-access/gql-types/graphql';
import { TimeZoneKindInternalRequest } from '../../../../../types/graphql-rest-converter';
import { getTimeParts } from '../../../../../../../utils/helpers';
import { HoursRange, TariffKindInternal as TariffKindInternalRest } from '../../../../../types/openapi/openapi-types';
import { HoursRangeFront, PrepareRelaysParams } from '../types';
import { tariffsForRequest } from './tariff-kind';

export const prepareRelaysToSend = ({
  relayConfig1,
  relayConfig2,
  relayConfig3,
  relayConfig4,
}: PrepareRelaysParams) => {
  return [
    {
      enabled: relayConfig1.enabled,
      index: relayConfig1.index,
      thresholdValue: relayConfig1.thresholdValue,
      timeOn: getSecondsByTime(relayConfig1.timeOn),
      timeOff: getSecondsByTime(relayConfig1.timeOff),
    },
    {
      enabled: relayConfig2.enabled,
      index: relayConfig2.index,
      thresholdValue: relayConfig2.thresholdValue,
      timeOn: getSecondsByTime(relayConfig2.timeOn),
      timeOff: getSecondsByTime(relayConfig2.timeOff),
    },
    {
      enabled: relayConfig3.enabled,
      index: relayConfig3.index,
      thresholdValue: relayConfig3.thresholdValue,
      timeOn: getSecondsByTime(relayConfig3.timeOn),
      timeOff: getSecondsByTime(relayConfig3.timeOff),
    },
    ...(relayConfig4
      ? [
          {
            enabled: relayConfig4.enabled,
            index: relayConfig4.index,
            thresholdValue: relayConfig4.thresholdValue,
            timeOn: getSecondsByTime(relayConfig4.timeOn),
            timeOff: getSecondsByTime(relayConfig4.timeOff),
          },
        ]
      : []),
  ];
};

export const prepareWorkingHoursToSend = (from: string, to: string) => {
  return { from: `${from}:00`, to: `${to}:00` };
};

const getSecondsByTime = (time: string) => {
  const timeParts = getTimeParts(time);
  return timeParts.hours * 3600 + timeParts.minutes * 60 + timeParts.seconds;
};

export const prepareHoursRangesToSend = (hoursRanges: HoursRangeFront[]): HoursRange[] => {
  return hoursRanges.map((range) => ({
    from: parseInt(range.from.replace(':00', '')),
    to: parseInt(range.to.replace(':00', '')),
    timeZoneKind: TimeZoneKindInternalRequest[range.timeZoneKind],
  }));
};

export const prepareOperatorAndTariffForRequest = (operator: string, tariffName: string): TariffKindInternalRest => {
  return (tariffsForRequest.find((x) => x.operator === operator.toLowerCase() && x.tariff === tariffName.toLowerCase())
    ?.kind || 0) as TariffKindInternalRest;
};

export const getTariffOperatorEnum = (operator: string, tariffName: string): TariffKindInternal | string => {
  return (
    tariffsForRequest.find((x) => x.operator === operator.toLowerCase() && x.tariff === tariffName.toLowerCase())
      ?.enum || ''
  );
};

export const checkIfTempMinWarning = (tempMin: number) => tempMin > 60;
